const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_PL_PLANNING",
    modulePath: "hml-new-netsuite.pl",
    moduleName: "pl",
    language: "pt",
    port: 8088,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
